import Head from "next/head";

import config from "config";

import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";
import CreateNewProject from "flows/market-mix-modelling/views/Create-Project";

const CreateProject = () => {
  return (
    <>
      <Head>
        <title>
          {config.SITE_NAME} | Create New Marketing Spend Mix/Attribution
          Analysis Project
        </title>
      </Head>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pb-4 mb-8">
          <h1 className="h2 text-center">
            Start Marketing Spend Impact Analysis
          </h1>
        </div>
        <CreateNewProject />
      </div>
    </>
  );
};

CreateProject.getLayout = (page) => <NewProjectLayout>{page}</NewProjectLayout>;

export default CreateProject;
